import React, { useEffect } from 'react'
import Header from '../common/Header'
import Footer from '../common/Footer'

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className='bgtheme py-4 h4 text-white text-center'>Privacy Policy</div>

      <div className="container my-5">
        <p><strong>Last updated:</strong> October 2025</p>
        <p>
          This Privacy Policy explains how Vasta Technologies FZ-LLC ("Vasta," "we," "our," or "us")
          collects, uses, and protects your personal data when you use our Platform.
        </p>

        <h4 className='mt-5'>1. Information We Collect</h4>
        <p>We may collect:</p>
        <ul>
          <li>Personal details such as name, email address, phone number, and location (if enabled).</li>
          <li>Usage data including information about how you interact with our app and website.</li>
          <li>Device data such as device type, operating system, and app version.</li>
          <li>We do not collect or store any payment details.</li>
        </ul>

        <h4 className='mt-5'>2. How We Use Your Information</h4>
        <ul>
          <li>Provide and improve our services.</li>
          <li>Facilitate bookings and communication with vendors.</li>
          <li>Send updates, offers, and promotions if you opted in.</li>
          <li>Ensure the security and functionality of our Platform.</li>
        </ul>

        <h4 className='mt-5'>3. Marketing Communication</h4>
        <p>
          You may choose to receive promotional emails, SMS, or push notifications about offers and
          discounts. You can withdraw your consent at any time through your profile settings or by contacting us.
        </p>

        <h4 className='mt-5'>4. Sharing of Information</h4>
        <p>
          We may share limited user data with vendors to complete a booking or improve service quality.
          We do not sell or rent your personal information to third parties.
        </p>

        <h4 className='mt-5'>5. Data Retention</h4>
        <p>
          Your personal data will be retained only for as long as necessary to provide our services or as required by UAE law.
        </p>

        <h4 className='mt-5'>6. Security</h4>
        <p>
          We use industry-standard security measures to protect your personal information. However,
          no online platform is completely secure, and you use Vasta at your own risk.
        </p>

        <h4 className='mt-5'>7. Your Rights</h4>
        <p>You have the right to:</p>
        <ul>
          <li>Access the personal data we hold about you.</li>
          <li>Request correction or deletion of your information.</li>
          <li>Withdraw consent for marketing communications.</li>
        </ul>

        <h4 className='mt-5'>8. Third-Party Links</h4>
        <p>
          Our Platform may contain links to third-party websites or services. Vasta is not responsible
          for their content or privacy practices.
        </p>

        <h4 className='mt-5'>9. Changes to This Policy</h4>
        <p>
          We may update this Privacy Policy from time to time. Updates will be posted on our website
          or app with the revised date.
        </p>

        <h4 className='mt-5'>10. Contact Us</h4>
        <p>
          If you have any questions or concerns about this Privacy Policy, please contact us at:&nbsp;
          <a href="mailto:adnan@vasta.ae">adnan@vasta.ae</a> or&nbsp;
          <a href="mailto:joshua@vasta.ae">joshua@vasta.ae</a>
        </p>
      </div>

      <Footer />
    </>
  )
}

export default PrivacyPolicy
